import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { InputSize, InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { SelectAcceptedType, SelectSize } from '@freelancer/ui/select';
import { TextSize } from '@freelancer/ui/text';
import { TooltipPosition } from '@freelancer/ui/tooltip';

export enum CustomFormFieldType {
  CHECKBOX = 'checkbox',
  INPUT = 'input',
  LOCATION = 'location',
  MULTI_SELECT = 'multi_select',
  SELECT = 'select',
}

@Component({
  selector: 'fl-custom-form-field',
  template: `
    <fl-bit *ngIf="id && labelText" [flMarginBottom]="Margin.XXSMALL">
      <fl-label [for]="id" [size]="TextSize.XSMALL">
        {{ labelText }}

        <fl-tooltip
          *ngIf="labelHintText"
          [message]="labelHintText"
          [position]="TooltipPosition.TOP_CENTER"
        >
          <fl-icon [name]="'ui-info-v2'" [size]="IconSize.SMALL"></fl-icon>
        </fl-tooltip>
      </fl-label>
    </fl-bit>

    <ng-container [ngSwitch]="type">
      <fl-checkbox
        *ngSwitchCase="CustomFormFieldType.CHECKBOX"
        [flTrackingLabel]="trackingLabel"
        [control]="control"
        [label]="labelText"
      ></fl-checkbox>

      <fl-input
        *ngSwitchCase="CustomFormFieldType.INPUT"
        [flTrackingLabel]="trackingLabel"
        [id]="id"
        [control]="control"
        [placeholder]="placeholder"
        [type]="inputType"
        [size]="InputSize.LARGE"
        [afterLabel]="inputAfterLabel"
        [autocomplete]="inputType !== InputType.DATE"
      ></fl-input>

      <fl-select
        *ngSwitchCase="CustomFormFieldType.SELECT"
        [flTrackingLabel]="trackingLabel"
        [id]="id"
        [control]="control"
        [placeholder]="placeholder"
        [size]="SelectSize.LARGE"
        [options]="selectOptions"
      ></fl-select>

      <fl-location-input
        *ngSwitchCase="CustomFormFieldType.LOCATION"
        [flTrackingLabel]="trackingLabel"
        [id]="id"
        [control]="control"
        [displayPostalCode]="true"
        [inputSize]="InputSize.LARGE"
      ></fl-location-input>

      <fl-multi-select
        *ngSwitchCase="CustomFormFieldType.MULTI_SELECT"
        [flTrackingLabel]="trackingLabel"
        [id]="id"
        [control]="control"
        [placeholder]="placeholder"
        [secondaryPlaceholder]="placeholder"
        [options]="selectOptions"
      ></fl-multi-select>
    </ng-container>
  `,
  styleUrls: ['./custom-form-field.component.scss'],
})
export class CustomFormFieldComponent {
  CustomFormFieldType = CustomFormFieldType;
  IconColor = IconColor;
  IconSize = IconSize;
  InputSize = InputSize;
  InputType = InputType;
  Margin = Margin;
  SelectSize = SelectSize;
  TextSize = TextSize;
  TooltipPosition = TooltipPosition;

  @Input() type: CustomFormFieldType;
  @Input() control: FormControl;
  @Input() controlValue?: string | number;
  @Input() trackingLabel?: string;
  @Input() id?: string;
  @Input() placeholder?: string;
  @Input() labelText?: string;
  @Input() labelHintText?: string;
  @Input() inputType?: InputType;
  @Input() inputAfterLabel?: string;
  @Input() selectOptions?: ReadonlyArray<SelectAcceptedType>;
}
